var render, staticRenderFns
import script from "./BaseMn.vue?vue&type=script&lang=js"
export * from "./BaseMn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f83c3f94",
  null
  
)

export default component.exports